import { routes } from "@constants/routes";
import { Link } from "react-router-dom";

const ForgotPasswordLink = () => {
  return (
    <div className="flex justify-end">
      <Link to={routes.auth.resetPassword.main} className="text-sm text-primary-700">
        Forgot password?
      </Link>
    </div>
  );
};

export default ForgotPasswordLink;
